import React, { useEffect, useState } from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { UrgencyScarcity } from '../components/UrgencyScarcity';
const PURCHASE_LINK = 'https://f13dpf-q0.myshopify.com/cart/47511845830810:1?channel=buy_button';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/vMd87Wc5TTB5dHjAnET4et/ChatGPT_Image_2_jul_2026,_09_55_38_p.m..png';
const RECRUITMENT_GUIDE_IMAGE = 'https://cdn.magicpatterns.com/uploads/ai5HZQKrQPdzo6UGXmiNag/Diseno_sin_titulo_(13).png';
const BONUS1_IMAGE = 'https://cdn.magicpatterns.com/uploads/hePzTgANxq5uEmiJv5jGxb/ChatGPT_Image_3_jul_2026,_01_00_30_a.m.png';
const BONUS2_IMAGE = 'https://cdn.magicpatterns.com/uploads/svm9HVj5a9NAXxDKtZvte8/ChatGPT_Image_3_jul_2026,_01_07_54_a.m.png';
const BONUS3_IMAGE = 'https://cdn.magicpatterns.com/uploads/wCdMLwq9KH2RUZ1z6fCvg7/ChatGPT_Image_3_jul_2026,_01_10_55_a.m.png';
const ELITE_PACK_LINK = 'https://f13dpf-q0.myshopify.com/cart/47516590014618:1?channel=buy_button';
function BuyButton({
  text,
  className = ''
}: {
  text: string;
  className?: string;
}) {
  return <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className={`block w-full text-center bg-green-600 hover:bg-green-700 text-white font-black py-5 px-6 rounded-lg text-lg md:text-xl leading-tight transition-all duration-200 btn-pulse shadow-lg hover:shadow-xl hover:-translate-y-0.5 ${className}`} style={{
    fontFamily: 'Montserrat, sans-serif'
  }} data-id="element-56">
      {text}
    </a>;
}
// Devuelve un Date "desplazado" a la hora de Argentina (Buenos Aires),
// de modo que getDay()/getDate()/getMonth() reflejen el calendario argentino.
function getArgentinaNow(): Date {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Argentina/Buenos_Aires',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
  }).formatToParts(new Date());
  const get = (type: string) => parts.find(p => p.type === type)?.value ?? '0';
  return new Date(parseInt(get('year'), 10), parseInt(get('month'), 10) - 1, parseInt(get('day'), 10), parseInt(get('hour'), 10) % 24, parseInt(get('minute'), 10), parseInt(get('second'), 10));
}
function StarRating() {
  return <div className="flex gap-0.5 text-yellow-400 text-xl" data-id="element-57">{'⭐'.repeat(5)}</div>;
}
export function SalesPage() {
  // Re-renderiza cada minuto para que el día cambie automáticamente al pasar
  // la medianoche (00:00 hs) según el calendario de Argentina.
  const [, setTick] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => setTick(t => t + 1), 60 * 1000);
    return () => clearInterval(interval);
  }, []);
  const days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  const today = getArgentinaNow();
  const dateTextUpper = `HOY ${days[today.getDay()].toUpperCase()} ${today.getDate()} DE ${months[today.getMonth()].toUpperCase()}`;
  return <div className="w-full bg-white" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-58">
      {/* STICKY URGENCY BAR */}
      <div className="sticky top-0 z-40 text-white py-3 px-4 text-center bg-[#85C3D7]" data-id="element-59">
        <div className="flex flex-wrap items-center justify-center gap-2 text-sm md:text-base font-bold" style={{
        fontFamily: 'Montserrat, sans-serif'
      }} data-id="element-60">
          <span data-id="element-61">⏳ OFERTA EXPIRA EN:</span>
          <CountdownTimer data-id="element-62" />
          <span data-id="element-63">|</span>
          <span data-id="element-64">🔥 SOLO QUEDAN 3 CUPOS {dateTextUpper} 🔥</span>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="max-w-3xl mx-auto px-4 py-0" data-id="element-65">
        {/* HERO SECTION */}
        <section className="py-10 text-center" data-id="element-66">
          {/* Tag */}
          <div className="inline-block bg-black text-white text-sm font-bold px-4 py-2 rounded-full mb-5 tracking-wide" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-67">
            📌 Para Emprendedoras NuSkin✨
          </div>

          {/* Main Headline */}
          <h1 className="text-3xl md:text-5xl font-black text-black leading-tight mb-4 uppercase text-center" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-68">
            Dejá de perseguir clientas.
            <br data-id="element-69" />
            Hacé que{' '}
            <span className="text-[#98CBDD] underline decoration-[#98CBDD]" data-id="element-70">
              ELLAS te PERSIGAN
            </span>{' '}
            a vos.
          </h1>

          {/* Product Image */}
          <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block mb-6 cursor-pointer" data-id="element-71">
            <img src={PRODUCT_IMAGE} alt="Megapack Fórmula UGC para Emprendedoras Nu Skin" className="w-full max-w-sm mx-auto rounded-2xl shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-72" />
          </a>

          {/* Subheadline */}
          <p className="md:text-2xl text-gray-800 mb-6 font-[700] text-[18px]" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-73">
            👉🏻{' '}
            <span className="underline decoration-[#98CBDD] decoration-4 underline-offset-2" data-id="element-74">
              Tu primera venta en menos de 7 días
            </span>{' '}
            con tu negocio de NuSkin, aunque no tengas experiencia, ni
            seguidores.
          </p>

          {/* Description */}
          <p className="text-base md:text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-75">
            Aplica el método <strong data-id="element-76">FÓRMULA UGC</strong> para que tu contenido{' '}
            <strong data-id="element-77">SI VENDA</strong> por vos <strong data-id="element-78">TODOS LOS DÍAS</strong>,
            usando solo tu celular y tu rutina real.
          </p>

          {/* Negative list */}
          <div className="bg-gray-50 border-l-4 border-red-500 rounded-lg p-5 mb-8 text-left space-y-3" data-id="element-79">
            <p className="flex items-start gap-2 text-gray-800 font-medium" data-id="element-80">
              ❌ <span data-id="element-81">Sin tener que enviar DMs en frío</span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 font-medium" data-id="element-82">
              ❌{' '}
              <span data-id="element-83">
                Sin tener que iniciar conversaciones incómodas en la fila del
                súper
              </span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 font-medium" data-id="element-84">
              ❌ <span data-id="element-85">Sin depender de familiares o amigos</span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 font-medium" data-id="element-86">
              ❌{' '}
              <span data-id="element-87">
                Sin publicar "placas / fotos catálogo" que{' '}
                <strong data-id="element-88">NO VENDEN.</strong>
              </span>
            </p>
          </div>

          {/* CTA Button */}
          <BuyButton text="👉 SÍ, QUIERO DEJAR DE PERSEGUIR Y ATRAER — ACCESO INMEDIATO" data-id="element-89" />
          <p className="text-sm text-gray-500 mt-3 font-medium" data-id="element-90">
            ✅ Acceso inmediato · Un solo pago · Garantía 7 días
          </p>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-91" />

        {/* PAIN SECTION */}
        <section className="py-10" data-id="element-92">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 leading-tight" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-93">
            Si sos emprendedora Nu Skin, dejame hacerte una pregunta honesta...
          </h2>

          <div className="space-y-4 mb-8" data-id="element-94">
            <div className="border border-gray-200 rounded-xl p-5 bg-[#DFEAF4]" data-id="element-95">
              <p className="text-base md:text-lg text-gray-800 leading-relaxed" data-id="element-96">
                Sentís que tenes{' '}
                <strong data-id="element-97">LOS MEJORES productos de belleza del mercado</strong>,
                pero aún así, las clientas <strong data-id="element-98">¿NO te lo compran?</strong>{' '}
                😩
              </p>
            </div>
            <div className="border border-gray-200 rounded-xl p-5 bg-[#DFEAF4]" data-id="element-99">
              <p className="text-base md:text-lg text-gray-800 leading-relaxed" data-id="element-100">
                Sentís que las <strong data-id="element-101">PERSEGUIS TODO EL TIEMPO</strong> ¿cuando
                debería de ser al revés? 😭
              </p>
            </div>
          </div>

          <p className="text-base text-gray-700 mb-6 text-center italic" data-id="element-102">
            Déjame decirte que te entiendo, yo también pasé por ahí.
            <br data-id="element-103" />
            <strong data-id="element-104">Pero la buena noticia es que tiene solución🩵</strong>
          </p>

          {/* Bold box */}
          <div className="text-white rounded-xl p-6 mb-6 text-center bg-[#98CBDD]" data-id="element-105">
            <p className="md:text-xl font-black text-[20px]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-106">
              El problema <span className="text-[#FFFFFF]" data-id="element-107">NO</span> son los
              productos, ni el precio.
              <br data-id="element-108" />
              Tampoco es porque no seas capaz.
            </p>
          </div>

          <p className="text-base md:text-lg text-gray-800 mb-6 text-center leading-relaxed" data-id="element-109">
            Sino porque te enseñaron <strong data-id="element-110">métodos del siglo pasado</strong>{' '}
            que hoy <strong data-id="element-111">NO FUNCIONAN</strong> y encima, te{' '}
            <strong data-id="element-112">DRENAN la energía.</strong>
          </p>

          {/* Broken heart list */}
          <div className="space-y-3 mb-6" data-id="element-113">
            <p className="flex items-start gap-2 text-gray-800 text-base" data-id="element-114">
              💔 <span data-id="element-115">Mandás mensajes y te clavan el visto.</span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 text-base" data-id="element-116">
              💔{' '}
              <span data-id="element-117">
                Publicás lo que te dice tu patrocinadora y no pasa nada.
              </span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 text-base" data-id="element-118">
              💔{' '}
              <span data-id="element-119">
                Te piden precio y te dicen que lo "tienen que pensar" o peor
                aún: <strong data-id="element-120">DESAPARECEN</strong> 😪
              </span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 text-base" data-id="element-121">
              💔 <span data-id="element-122">Tenes miedo de estar perdiendo el tiempo.</span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 text-base" data-id="element-123">
              💔 <span data-id="element-124">Te frustra no generar dinero.</span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 text-base" data-id="element-125">
              💔 <span data-id="element-126">Dudas si este negocio es para vos.</span>
            </p>
          </div>

          <p className="text-base text-gray-700 italic text-center border-l-4 border-gray-300 pl-4" data-id="element-127">
            Y lo peor: ves a otras líderes creciendo, vendiendo cada mes y{' '}
            <strong data-id="element-128">NO entendes cómo</strong>... o por qué a ellas les funciona
            y a vos no.
          </p>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-129" />
      </div>

      {/* TRUTH SECTION - Full width black */}
      <section className="text-white py-12 px-4 bg-[#000000]" data-id="element-130">
        <div className="max-w-3xl mx-auto" data-id="element-131">
          <div className="text-center mb-4" data-id="element-132">
            <span className="inline-block text-white text-xs md:text-sm font-bold px-4 py-2 rounded-full uppercase tracking-widest bg-[#FD3A6B]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-133">
              EL PROBLEMA
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-center mb-8 leading-tight" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-134">
            La verdad que nadie en tu línea ascendente
            <br data-id="element-135" />
            <span className="text-yellow-300" data-id="element-136">te está diciendo:</span>
          </h2>

          <div className="space-y-4 text-base md:text-lg text-gray-200 leading-relaxed" data-id="element-137">
            <p data-id="element-138">
              El modelo de{' '}
              <strong className="text-white" data-id="element-139">
                "hace una lista de 100 personas y contactalos uno por uno"
              </strong>{' '}
              fue diseñado en los años 80.
            </p>
            <p data-id="element-140">
              Antes de Instagram. Antes de los Reels. Antes de que el consumidor
              promedio recibiera{' '}
              <strong className="text-yellow-300" data-id="element-141">
                10.000 estímulos visuales por día.
              </strong>
            </p>
            <p className="text-xl font-bold text-white text-center py-4" data-id="element-142">
              Hoy, la clienta que te va a comprar{' '}
              <span className="text-yellow-300" data-id="element-143">NO quiere que la busques.</span>
              <br data-id="element-144" />
              Quiere encontrarte{' '}
              <span className="text-[#FDE047]" data-id="element-145">ELLA sola.</span>
            </p>
            <p data-id="element-146">
              Y eso solo ocurre cuando tu contenido{' '}
              <strong className="text-white" data-id="element-147">trabaja para vos</strong> mientras
              haces tu rutina: desayunas, llevas a tus hijos al colegio u otras
              tareas.
            </p>
          </div>

          <div className="text-black rounded-xl p-6 my-8 text-center bg-[#FFFFFF]" data-id="element-148">
            <p className="text-base md:text-lg font-bold leading-relaxed" data-id="element-149">
              El UGC (Contenido Generado por el Usuario) cambió la forma de
              consumir de las clientas. ✅ Y SI NO LO DOMINÁS, NO TENÉS VENTAS.
              Así de simple.
            </p>
          </div>

          <div className="space-y-3 text-base md:text-lg text-gray-200" data-id="element-150">
            <p className="text-center text-[20px] font-[800] text-[#FFFFFF]" data-id="element-151">
              Pero <strong className="text-[#FDE047]" data-id="element-152">OJO.</strong> NO es
              simplemente grabarte usando el producto. Eso lo hace cualquiera.
              ❌
            </p>
            <p className="text-center font-bold text-xl text-[#FFFFFF] bg-[#000000]" data-id="element-153">
              Se trata de una{' '}
              <span className="text-yellow-300" data-id="element-154">
                ESTRUCTURA de videos que SI CONVIERTEN
              </span>{' '}
              en ventas.
            </p>
          </div>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-4" data-id="element-155">
        {/* PRODUCT INTRO */}
        <section className="py-10 text-center" data-id="element-156">
          <div className="text-center mb-4" data-id="element-157">
            <span className="inline-block text-xs md:text-sm font-bold px-4 py-2 rounded-full uppercase tracking-widest text-[#FFFFFF] bg-[#D7B2D8]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-158">
              LA SOLUCIÓN
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-black mb-4 leading-tight" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-159">
            ✨ Fórmula UGC para
            <br data-id="element-160" />
            Emprendedoras Nu Skin ✨
          </h2>

          <div className="flex justify-center mb-6" data-id="element-161">
            <img src="https://cdn.magicpatterns.com/uploads/6S5k6MsQnxyBY3GvsZzzuj/ChatGPT_Image_3_jul_2026,_12_48_57_a.m.png" alt="Fórmula UGC para Emprendedoras Nu Skin" className="w-full max-w-md rounded-2xl shadow-xl" data-id="element-162" />
          </div>

          <p className="text-lg md:text-xl font-bold text-gray-700 mb-8" data-id="element-163">
            Un sistema <strong data-id="element-164">COMPLETO</strong> para que{' '}
            <strong data-id="element-165">TRANSFORMES</strong> tu forma de trabajar y tus ventas esta
            misma semana.
          </p>

          <h3 className="text-2xl font-black text-black mb-6 text-center" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-166">
            ¿QUÉ VAS A LOGRAR CON ESTE PROGRAMA?
          </h3>

          <div className="space-y-3 text-left mb-8" data-id="element-167">
            <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-168">
              ✅{' '}
              <span data-id="element-169">
                <strong data-id="element-170">DEJAR de PERSEGUIR</strong> clientas y que en cambio{' '}
                <strong data-id="element-171">ELLAS te PERSIGAN a VOS.</strong>
              </span>
            </p>
            <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-172">
              ✅{' '}
              <span data-id="element-173">
                Te tomen de <strong data-id="element-174">REFERENTE</strong> en el mercado y{' '}
                <strong data-id="element-175">CONFÍEN</strong> en vos.
              </span>
            </p>
            <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-176">
              ✅{' '}
              <span data-id="element-177">
                Te pidan info para <strong data-id="element-178">COMPRAR REALMENTE</strong> y NO por
                curiosidad.
              </span>
            </p>
            <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-179">
              ✅{' '}
              <span data-id="element-180">
                Tengas nuevas <strong data-id="element-181">CLIENTAS</strong> que{' '}
                <strong data-id="element-182">CONSUMEN PRODUCTOS TODOS LOS MESES</strong>
              </span>
            </p>
            <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-183">
              ✅{' '}
              <span data-id="element-184">
                Tengas nuevas <strong data-id="element-185">SOCIAS</strong> que{' '}
                <strong data-id="element-186">TRABAJEN EN TU EQUIPO</strong>
              </span>
            </p>
            <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-187">
              ✅{' '}
              <span data-id="element-188">
                Logres llegar al próximo <strong data-id="element-189">RANGO DE LA COMPAÑÍA</strong>
              </span>
            </p>
          </div>

          <p className="text-base text-gray-700 mb-4" data-id="element-190">
            Esto es exactamente lo que realmente me ayudó a despegar mi negocio:
          </p>

          <div className="text-white rounded-xl p-6 mb-6 bg-[#ECD7EB]" data-id="element-191">
            <p className="text-xl font-black mb-2 text-[#000000]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-192">
              🔥 Método FÓRMULA UGC
            </p>
            <p className="font-bold text-lg text-[#000000]" data-id="element-193">
              (Rutina → Problema → Solución)
            </p>
          </div>

          <div className="bg-gray-50 border border-gray-200 rounded-xl p-5 text-left mb-6" data-id="element-194">
            <p className="text-base text-gray-800 leading-relaxed" data-id="element-195">
              <strong data-id="element-196">UGC estratégico</strong> = lograr que la persona piense:
              <br data-id="element-197" />
              <br data-id="element-198" />
              <span className="text-green-600 font-bold" data-id="element-199">
                "ella es como yo"
              </span>{' '}
              → <span className="text-green-600 font-bold" data-id="element-200">"eso me pasa"</span>{' '}
              →{' '}
              <span className="text-green-600 font-bold" data-id="element-201">
                "lo necesito" → "lo quiero."
              </span>
              .
              <br data-id="element-202" />
              <br data-id="element-203" />
              Resultado: antes de que vos respondas DM… las clientas{' '}
              <strong data-id="element-204">
                YA están decididas, te escriben Y TE COMPRAN a vos
              </strong>{' '}
              💸
            </p>
          </div>

          {/* Mid-page CTA */}
          <BuyButton text="🚀 QUIERO ACCEDER A LA FÓRMULA UGC AHORA" data-id="element-205" />
          <p className="text-sm text-gray-500 mt-3" data-id="element-206">
            ✅ Acceso inmediato · Un solo pago · Garantía 7 días
          </p>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-207" />

        {/* WHAT'S INCLUDED */}
        <section className="py-10" data-id="element-208">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-209">
            ¿Qué incluye exactamente?
          </h2>

          <div className="flex justify-center mb-8" data-id="element-210">
            <img src="https://cdn.magicpatterns.com/uploads/cBa9qzbkfwLJk47oktobBJ/Diseno_sin_titulo_(21).png" alt="Qué incluye exactamente" className="w-full max-w-md rounded-2xl shadow-xl" data-id="element-211" />
          </div>

          <div className="space-y-4" data-id="element-212">
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#ECD7EB]" data-id="element-213">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-214">
                1
              </div>
              <div data-id="element-215">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-216">
                  Módulo 1
                </p>
                <p className="text-gray-700 text-sm" data-id="element-217">
                  Bases y fundamentos del UGC (Contenido Generado por el
                  Usuario)
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#ECD7EB]" data-id="element-218">
              <div className="bg-black font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-[#FFFFFF]" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-219">
                2
              </div>
              <div data-id="element-220">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-221">
                  Módulo 2
                </p>
                <p className="text-gray-700 text-sm" data-id="element-222">
                  Estructura de videos que SI VENDEN
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#ECD7EB]" data-id="element-223">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-224">
                3
              </div>
              <div data-id="element-225">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-226">
                  Módulo 3
                </p>
                <p className="text-gray-700 text-sm" data-id="element-227">
                  El Arte de Cómo vender SIN VENDER
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#ECD7EB]" data-id="element-228">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-229">
                4
              </div>
              <div data-id="element-230">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-231">
                  Módulo 4
                </p>
                <p className="text-gray-700 text-sm" data-id="element-232">
                  Ganchos Magnéticos que facturan
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#ECD7EB]" data-id="element-233">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-234">
                5
              </div>
              <div data-id="element-235">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-236">
                  Módulo 5
                </p>
                <p className="text-gray-700 text-sm" data-id="element-237">
                  El Cierre Invisible (Protocolo 24/48/72hs)
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#ECD7EB]" data-id="element-238">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-239">
                6
              </div>
              <div data-id="element-240">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-241">
                  Módulo 6
                </p>
                <p className="text-gray-700 text-sm" data-id="element-242">
                  Mentalidad de Creadora Millonaria
                </p>
              </div>
            </div>
            <div className="border-2 border-green-600 rounded-xl p-5 flex gap-4 items-start bg-[#F0FDF4]" data-id="element-243">
              <div className="bg-green-600 text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-244">
                7
              </div>
              <div data-id="element-245">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-246">
                  Módulo 7
                </p>
                <p className="text-gray-700 text-sm" data-id="element-247">
                  Tu próximo Nivel - De cero o pocas ventas a Vendo todas las
                  semanas
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-248" />

        {/* FOR YOU / NOT FOR YOU */}
        <section className="py-10" data-id="element-249">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-250">
            ¿PARA QUIÉN ES ESTE PROGRAMA?
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-251">
            <div className="bg-green-50 border-2 border-green-600 rounded-xl p-6" data-id="element-252">
              <h3 className="text-xl font-black text-green-700 mb-4 text-center" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-253">
                ✅ Esto es PARA vos si:
              </h3>
              <div className="space-y-3 text-sm text-gray-800" data-id="element-254">
                <p data-id="element-255">
                  ✅ Acabas de iniciar o ya llevas +1 mes en Nu Skin y tus
                  ventas NO llegan como esperabas
                </p>
                <p data-id="element-256">
                  ✅ No sabes qué publicar en Instagram y sólo usas las fotos
                  oficiales de la empresa
                </p>
                <p data-id="element-257">
                  ✅ Alguien te preguntó el precio, desapareció y no supiste qué
                  hacer
                </p>
                <p data-id="element-258">
                  ✅ Querés que tu perfil atraiga clientas y socias sin que
                  tengas que perseguirlas a diario
                </p>
                <p data-id="element-259">
                  ✅ Tenés menos de 60-90 minutos al día para crear contenido y
                  querés maximizar tu tiempo
                </p>
              </div>
            </div>
            <div className="bg-gray-50 border-2 border-gray-300 rounded-xl p-6" data-id="element-260">
              <h3 className="text-xl font-black text-gray-700 mb-4 text-center" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-261">
                ❌ Esto NO es para vos si:
              </h3>
              <div className="space-y-3 text-sm text-gray-800" data-id="element-262">
                <p data-id="element-263">
                  ❌ Buscas hacerte rica de la noche a la mañana sin trabajar ni
                  aprender nuevas estrategias de venta (UGC)
                </p>
                <p data-id="element-264">❌ No estás dispuesta a mostrar ni tus manos en cámara</p>
                <p data-id="element-265">
                  ❌ Querés seguir usando el método de "amplia tu lista y
                  escríbele a tus 100 contactos"
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-266" />

        {/* BEFORE / AFTER */}
        <section className="py-10" data-id="element-267">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-268">
            ANTES vs DESPUÉS
            <br data-id="element-269" />
            <span className="text-green-600" data-id="element-270">(con Fórmula UGC)</span>
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-271">
            <div className="bg-red-50 border-2 border-red-400 rounded-xl p-6" data-id="element-272">
              <h3 className="text-lg font-black text-red-600 mb-4 text-center" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-273">
                😩 ANTES de Fórmula UGC
              </h3>
              <div className="space-y-3 text-sm text-gray-800" data-id="element-274">
                <p data-id="element-275">
                  ❌ Te drenabas contactando en frío y persiguiendo clientas que
                  no compran
                </p>
                <p data-id="element-276">❌ Improvisabas contenido y terminabas agotada</p>
                <p data-id="element-277">❌ No lograbas cerrar nuevas ventas todas las semanas</p>
              </div>
            </div>
            <div className="bg-green-50 border-2 border-green-500 rounded-xl p-6" data-id="element-278">
              <h3 className="text-lg font-black text-green-700 mb-4 text-center" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-279">
                😍 DESPUÉS de Fórmula UGC
              </h3>
              <div className="space-y-3 text-sm text-gray-800" data-id="element-280">
                <p data-id="element-281">✅ No perseguís más clientas, las atraés </p>
                <p data-id="element-282">✅ Tenés una estructura de contenido que SI VENDE</p>
                <p data-id="element-283">✅ Lográs cerrar nuevas ventas TODAS las semanas </p>
                <p data-id="element-284">✅ Tenés tiempo y energía para tu familia y otras tareas</p>
              </div>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-285" />

        {/* TESTIMONIALS */}
        <section className="py-10" data-id="element-286">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-287">
            Testimonios de emprendedoras que ya
            <br data-id="element-288" />
            <span className="text-green-600" data-id="element-289">aplicaron Fórmula UGC:</span>
          </h2>

          <div className="space-y-5" data-id="element-290">
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-291">
              <StarRating data-id="element-292" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-293">
                "Llevaba 8 meses en Nu Skin sin superar las 3 ventas al mes.
                Apliqué el Método de Fórmula UGC en mis Reels y en la segunda
                semana tuve 7 personas escribiéndome sin yo haberles escrito
                primero. Cerré 5 ventas en un sólo fin de semana, estoy
                feliiiiz!!"
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-294">
                — Valentina R. · Distribuidora Nu Skin · Córdoba, Argentina.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-295">
              <StarRating data-id="element-296" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-297">
                "Lo que más me cambió fue aprender a NO responder el precio en
                los comentarios. Ese solo cambio me triplicó las conversaciones
                reales en DM en menos de 1 semana."
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-298">
                — Mariana T. · Distribuidora Nu Skin · Mendoza, Argentina.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-299">
              <StarRating data-id="element-300" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-301">
                "Tenía pánico de hablar a cámara. La guía de Fórmula UGC me hizo
                darme cuenta de que mi baño con luz de ventana era todo lo que
                necesitaba. Mi primer Reel honesto llegó a 4,200 reproducciones.
                Nunca había pasado de 80."
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-302">
                — Andrea L. · Distribuidora Nu Skin · Tucumán, Argentina.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-303">
              <StarRating data-id="element-304" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-305">
                "El script de DM para cuando preguntan el precio lo copié
                textual. Funcionó la primera vez que lo usé. La chica terminó
                comprando el kit completo, luego de seguir los pasos y no solo
                la LumiSpa."
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-306">
                — Camila P. · Distribuidora Nu Skin · CABA, Argentina.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-307">
              <StarRating data-id="element-308" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-309">
                "Agregué la Guía de Reclutamiento y Vende por Historias, y en 3
                semanas tuve 2 socias nuevas que llegaron solas después de ver
                mis Stories de negocio. Nunca las busqué. Ellas me escribieron
                primero y las cerré. Graciass!"
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-310">
                — Sofía M. · Distribuidora Nu Skin · Tierra del Fuego,
                Argentina.
              </p>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-311" />

        {/* BONUSES SECTION */}
        <section className="py-10" id="compra" data-id="element-312">
          <div className="text-center mb-8" data-id="element-313">
            <span className="text-white font-black text-sm px-4 py-2 rounded-full uppercase tracking-wide bg-[#16a34a]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-314">
              🎁 3 BONOS — SOLO POR HOY
            </span>
          </div>

          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-10 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-315">
            🎁 Bonos de REGALO incluidos HOY
          </h2>

          {/* Bonus 1 */}
          <div className="mb-10 text-center" data-id="element-316">
            <div className="inline-block font-black text-sm px-4 py-2 rounded-full mb-4 uppercase tracking-wide text-[#FFFFFF] bg-[#16a34a]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-317">
              🎁 Bono #1
            </div>
            <h3 className="text-xl font-black text-black mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-318">
              El Script Perfecto de DM
            </h3>
            <p className="text-green-600 font-bold mb-4" data-id="element-319">
              De "Hola, info" a "Ya pagué"
            </p>
            <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-320">
              <img src={BONUS1_IMAGE} alt="Bono #1 - Script Perfecto de DM" className="w-full max-w-sm mx-auto rounded-xl shadow-lg hover:scale-105 transition-transform duration-300" style={{
              width: '400px',
              height: '400px',
              objectFit: 'contain'
            }} data-id="element-321" />
            </a>
            <p className="text-gray-700 text-sm mt-4 max-w-md mx-auto" data-id="element-322">
              La secuencia de mensajes para convertir curiosidad en compra SIN
              sonar desesperada: qué decir, cuándo preguntar, cómo guiar, y cómo
              cerrar con seguridad.
            </p>
          </div>

          {/* Bonus 2 */}
          <div className="mb-10 text-center" data-id="element-323">
            <div className="inline-block font-black text-sm px-4 py-2 rounded-full mb-4 uppercase tracking-wide text-[#FFFFFF] bg-[#16a34a]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-324">
              🎁 Bono #2
            </div>
            <h3 className="text-xl font-black text-black mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-325">
              Banco de Plantillas, Ideas y Recursos Listos para usar
            </h3>
            <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-326">
              <img src={BONUS2_IMAGE} alt="Bono #2 - Banco de Plantillas" className="w-full max-w-sm mx-auto rounded-xl shadow-lg hover:scale-105 transition-transform duration-300" style={{
              width: '400px',
              height: '400px',
              objectFit: 'contain'
            }} data-id="element-327" />
            </a>
            <p className="text-gray-700 text-sm mt-4 max-w-md mx-auto" data-id="element-328">
              Para que no empieces nunca más desde cero: plantillas y recursos
              para crear contenido UGC más rápido, con estructura, y con
              claridad de qué mostrar y cómo mostrarlo.
            </p>
          </div>

          {/* Bonus 3 */}
          <div className="mb-10 text-center" data-id="element-329">
            <div className="inline-block font-black text-sm px-4 py-2 rounded-full mb-4 uppercase tracking-wide text-[#FFFFFF] bg-[#16a34a]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-330">
              🎁 Bono #3
            </div>
            <h3 className="text-xl font-black text-black mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-331">
              Calendario de Contenido que te ahorra HORAS de tu tiempo
            </h3>
            <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-332">
              <img src={BONUS3_IMAGE} alt="Bono #3 - Calendario de Contenido" className="w-full max-w-sm mx-auto rounded-xl shadow-lg hover:scale-105 transition-transform duration-300" style={{
              width: '400px',
              height: '400px',
              objectFit: 'contain'
            }} data-id="element-333" />
            </a>
            <p className="text-gray-700 text-sm mt-4 max-w-md mx-auto" data-id="element-334">
              Listo para organizar tu semana de publicaciones sin estrés: qué
              publicar cada día con el método probado UGC para atraer clientas.
            </p>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-335" />

        {/* TWO FUTURES */}
        <section className="py-10" data-id="element-336">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-337">
            Hay dos versiones de vos dentro de 30 días 👇🏻
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-338">
            <div className="bg-gray-100 border-2 border-gray-400 rounded-xl p-6" data-id="element-339">
              <p className="text-2xl text-center mb-3" data-id="element-340">😭</p>
              <p className="text-sm text-gray-700 leading-relaxed" data-id="element-341">
                Seguís enviando difusiones de Whatsapp que nadie responde.
                Seguís publicando fotos "catálogo" que el algoritmo ignora. Y lo
                peor de todo: seguís sin ventas y viendo cómo otras socias sí
                crecen cada mes... sin entender qué están haciendo diferente.
              </p>
            </div>
            <div className="bg-green-50 border-2 border-green-500 rounded-xl p-6" data-id="element-342">
              <p className="text-2xl text-center mb-3" data-id="element-343">😍</p>
              <p className="text-sm text-gray-700 leading-relaxed" data-id="element-344">
                Abrís Instagram por la mañana y tenés 7 mensajes nuevos de
                mujeres preguntando por los kits. Tenés un sistema de Contenido
                UGC que te genera ventas todas las semanas. Al fin tenes nuevas
                socias que llegaron solas. Tenés claridad sobre qué publicar,
                cómo estructurarlo y qué decir cuando alguien te escribe.
              </p>
            </div>
          </div>
        </section>

        {/* URGENCY & SCARCITY */}
        <UrgencyScarcity data-id="element-345" />

        {/* PRICING SECTION */}
        <section className="py-10 text-center" id="precio" data-id="element-346">
          <h2 className="text-2xl md:text-3xl font-black text-black mb-2 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-347">
            ⏰ Oferta por tiempo limitado
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-348">Todo lo que recibís hoy:</p>

          <div className="bg-black text-white rounded-2xl p-6 md:p-8 mb-6" data-id="element-349">
            <div className="space-y-3 text-left mb-8" data-id="element-350">
              <p className="flex items-start gap-2 text-sm md:text-base" data-id="element-351">
                ✅{' '}
                <span data-id="element-352">
                  <strong data-id="element-353">7 módulos completos</strong> — Fórmula UGC para
                  Emprendedoras Nu Skin
                </span>
              </p>
              <p className="flex items-start gap-2 text-sm md:text-base" data-id="element-354">
                🎁{' '}
                <span data-id="element-355">
                  <strong data-id="element-356">Bono #1:</strong> Script perfecto de DM ("Hola, info"
                  → "Ya pagué")
                </span>
              </p>
              <p className="flex items-start gap-2 text-sm md:text-base" data-id="element-357">
                🎁{' '}
                <span data-id="element-358">
                  <strong data-id="element-359">Bono #2:</strong> Banco de plantillas, ideas y
                  recursos listos para usar
                </span>
              </p>
              <p className="flex items-start gap-2 text-sm md:text-base" data-id="element-360">
                🎁{' '}
                <span data-id="element-361">
                  <strong data-id="element-362">Bono #3:</strong> Calendario de contenido que ahorra
                  horas
                </span>
              </p>
              <p className="flex items-start gap-2 text-sm md:text-base" data-id="element-363">
                📲 <span data-id="element-364">Descarga digital + acceso inmediato</span>
              </p>
              <p className="flex items-start gap-2 text-sm md:text-base" data-id="element-365">
                ♾️ <span data-id="element-366">Acceso de por vida (un solo pago)</span>
              </p>
            </div>

            <div className="border-t border-gray-600 pt-6" data-id="element-367">
              <p className="text-sm line-through mb-1 text-[#9299A4]" data-id="element-368">
                Precio regular: $79.990 ARS
              </p>
              <p className="text-4xl md:text-5xl font-black mb-1 text-[#FEF08A]" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-369">
                $49.990 ARS
              </p>
              <p className="font-bold text-sm mb-1 text-[#FEF08A]" data-id="element-370">
                🔥 VALOR DE LANZAMIENTO - 3 cuotas 🔥
              </p>
              <p className="text-gray-400 text-xs" data-id="element-371">
                ✔ Un solo pago · ✔ Sin suscripción · ✔ Desde el celular
              </p>
            </div>
          </div>

          <BuyButton text="👉 ¡SÍ, QUIERO ACCEDER AHORA! (Acceso inmediato)" className="text-xl py-6" data-id="element-372" />
          <p className="text-sm text-gray-500 mt-3 font-medium" data-id="element-373">
            ✅ Garantía 7 días · Acceso inmediato · Un solo pago
          </p>
        </section>

        {/* ORDER BUMP - Below main offer */}

        {/* DIVIDER */}

        {/* GUARANTEE */}
        <section className="py-10" data-id="element-374">
          <div className="bg-gray-50 border-4 border-black rounded-2xl p-6 md:p-8 text-center" data-id="element-375">
            <div className="text-5xl mb-4" data-id="element-376">🛡️</div>
            <h2 className="text-2xl md:text-3xl font-black text-black mb-4" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-377">
              Tu Inversión Está 100% Protegida
            </h2>
            <h3 className="text-xl font-bold text-green-600 mb-4" data-id="element-378">
              Garantía de Satisfacción Total — 7 Días
            </h3>
            <p className="text-gray-700 text-base leading-relaxed mb-4" data-id="element-379">
              Aplicá el Método Fórmula UGC durante los próximos 7 días. Si no
              estás conforme te devuelvo el 100% de tu dinero, sin vueltas.
            </p>
            <p className="text-gray-700 text-base leading-relaxed mb-4" data-id="element-380"></p>
            <p className="text-gray-800 font-bold text-base" data-id="element-381"></p>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-382" />

        {/* FAQ */}
        <section className="py-10" data-id="element-383">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-384">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-385">
            <div className="border border-gray-200 rounded-xl p-5" data-id="element-386">
              <p className="font-bold text-black mb-2" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-387">
                ❓ ¿Funciona si tengo muy pocos seguidores?
              </p>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-388">
                Sí. El algoritmo de Instagram y TikTok distribuye el contenido
                basado en relevancia y retención, no en número de seguidores.
                Cuentas de 200 seguidores han generado ventas reales aplicando
                estos principios. Lo que importa no es cuántos te siguen — es
                qué tan magnético es tu contenido.
              </p>
            </div>
            <div className="border border-gray-200 rounded-xl p-5" data-id="element-389">
              <p className="font-bold text-black mb-2" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-390">
                ❓ ¿Tengo que saber editar video?
              </p>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-391">
                No. El sistema está diseñado para grabarse y publicarse
                directamente desde el celular usando las herramientas nativas de
                Instagram Reels o TikTok. Sin CapCut avanzado. Sin Premiere. Sin
                nada que no sepas hacer ya.
              </p>
            </div>
            <div className="border border-gray-200 rounded-xl p-5" data-id="element-392">
              <p className="font-bold text-black mb-2" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-393">
                ❓ ¿Funciona solo para la LumiSpa o para todos los productos Nu
                Skin?
              </p>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-394">
                Para todos. El Método Formula UGC se adapta a cualquier
                producto, tecnología o suplemento: Galvánica Spa, ageLOC, Boost,
                TR90, Epoch. Hay estructuras y ganchos específicos para cada
                categoría de producto.
              </p>
            </div>
            <div className="border border-gray-200 rounded-xl p-5" data-id="element-395">
              <p className="font-bold text-black mb-2" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-396">
                ❓ ¿La guía de reclutamiento es solo para emprendedoras nuevas?
              </p>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-397">
                Funciona para cualquier nivel, pero está especialmente diseñada
                para quienes están construyendo su primera línea descendente y
                no saben cómo hablar del negocio en redes sin sonar a "es una
                pirámide".
              </p>
            </div>
            <div className="border border-gray-200 rounded-xl p-5" data-id="element-398">
              <p className="font-bold text-black mb-2" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-399">
                ❓ ¿En cuánto tiempo veo los primeros resultados?
              </p>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-400">
                Las primeras interacciones y DMs llegan en 24-72 horas después
                del primer Reel bien estructurado. Las primeras ventas orgánicas
                suelen ocurrir entre el día 3 y el día 14, dependiendo de tu
                constancia y tu audiencia actual.
              </p>
            </div>
            <div className="border border-gray-200 rounded-xl p-5" data-id="element-401">
              <p className="font-bold text-black mb-2" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-402">
                ❓ ¿Qué pasa si lo compro y no funciona para mí?
              </p>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-403">
                Tenés 7 días de garantía total. Sin preguntas. Sin condiciones.
                Sin formularios. Escribís un mensaje y te devuelvo el dinero
                completo. Así de simple.
              </p>
            </div>
          </div>
        </section>

        {/* FINAL CTA */}
        <section className="py-10 text-center" data-id="element-404">
          <div className="bg-black text-white rounded-2xl p-8 mb-6" data-id="element-405">
            <h2 className="text-2xl md:text-3xl font-black mb-4" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-406">
              ¿Estás lista para que las clientas
              <br data-id="element-407" />
              <span className="text-yellow-300" data-id="element-408">te persigan a VOS?</span>
            </h2>
            <p className="text-gray-300 mb-6 text-base" data-id="element-409">
              Acceso inmediato · Garantía 7 días · Un solo pago
            </p>
            <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-green-500 hover:bg-green-400 text-white font-black py-6 px-6 rounded-lg text-xl leading-tight transition-all duration-200 btn-pulse shadow-xl" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-410">
              👉 ¡SÍ, QUIERO ACCEDER AHORA!
              <br data-id="element-411" />
              <span className="text-base font-bold opacity-90" data-id="element-412">
                (Acceso inmediato)
              </span>
            </a>
            <p className="text-gray-400 text-sm mt-4" data-id="element-413">
              🔥 HOY: $19.990 ARS · Precio regular:{' '}
              <span className="line-through" data-id="element-414">$79.990 ARS</span>
            </p>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="py-8 border-t border-gray-200 text-center" data-id="element-415">
          <p className="text-gray-500 text-xs leading-relaxed" data-id="element-416">
            © Fórmula UGC para Emprendedoras Nu Skin. Todos los derechos
            reservados.
            <br data-id="element-417" />
            <em data-id="element-418">
              Este producto es independiente y no está afiliado, patrocinado ni
              respaldado por Nu Skin Enterprises Inc.
            </em>
          </p>
        </footer>
      </div>

      {/* Social Proof Popup */}
      <SocialProofPopup data-id="element-419" />
    </div>;
}